import pkceChallenge from 'pkce-challenge';
import { MemoryLastCodeVerifierProvider } from './MemoryLastCodeVerifierProvider';

export class PKCEChallengeProvider {
    static inject = () => [MemoryLastCodeVerifierProvider];
    constructor(private lastPKCEVerifierProvider: MemoryLastCodeVerifierProvider){}
    createChallenge = (): { code_verifier: string, code_challenge: string } => {
        const { code_verifier, code_challenge } = pkceChallenge();

        this.lastPKCEVerifierProvider.store({ code_verifier });

        return { code_verifier, code_challenge };
    }

    getLastVerifier = (): { code_verifier?: string } => {
        return this.lastPKCEVerifierProvider.getLastVerifier();
    }
}
